import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DataService {
  constructor() {}
  private _loading = new BehaviorSubject<boolean>(false);
  loading = this._loading.asObservable();
  public displayLoading(request: boolean = true) {
    setTimeout(() => {
      this._loading.next(request);
    });
  }
}
